import { useEffect, useState } from "react";
import api from "@/lib/api";

export function UserAvatar({ user, size = "h-8 w-8", textSize = "text-sm", testId = "user-avatar" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    let cancelled = false;
    if (user?.avatar_path && user?.id) {
      api
        .get(`/profile/avatar/${user.id}`, { responseType: "blob" })
        .then((r) => {
          if (cancelled) return;
          url = URL.createObjectURL(r.data);
          setSrc(url);
        })
        .catch(() => {});
    } else {
      setSrc(null);
    }
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [user?.avatar_path, user?.id]);

  if (src) {
    return <img src={src} alt={user?.name || "avatar"} className={`${size} shrink-0 rounded-full object-cover`} data-testid={`${testId}-image`} />;
  }
  return (
    <span
      className={`flex ${size} shrink-0 items-center justify-center rounded-full bg-sky-600 font-display ${textSize} font-bold text-white`}
      data-testid={`${testId}-initial`}
    >
      {(user?.name || user?.email || "?")[0].toUpperCase()}
    </span>
  );
}
